<script setup lang="ts">

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
  },
  config: {
    innerComponent?: Component
  },
}>();
const data = computed(() => ({
  theme: props.block?.theme,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data" />
</template>
